var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPath = function SvgIconPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.75 4.25a1 1 0 0 0 0 2h9a2 2 0 0 1 0 4h-9a4.75 4.75 0 1 0 0 9.5h8.907a3.252 3.252 0 0 0 6.343-1 3.25 3.25 0 0 0-6.343-1H6.75a2.75 2.75 0 1 1 0-5.5h9a4 4 0 1 0 0-8zm10.75 14.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconPath;